export default {
  '--color-primary': '#25857a',
  '--color-secondary': '#d3e7c4',
  '--text-color': '#394045',
  '--gray': '#a1abb3',
};
